import { PROBLEM_CONTENT_TYPE, ProblemSchema } from "../primitives/problem.js";
import { ERROR_CATALOGUE } from "../errors/catalogue.js";
export const JSON_CONTENT_TYPE = 'application/json';
/** A JSON success response. */
export function jsonResponse(schema, description) {
    return { description, content: { [JSON_CONTENT_TYPE]: { schema } } };
}
/**
 * A problem+json failure response. Pass the catalogue slugs that can produce this status, and the
 * description names them, so the generated document tells a client which `code` values to expect
 * without anyone maintaining a second list.
 */
export function problemResponse(description, ...slugs) {
    const codes = slugs.map((slug) => slug.replaceAll('-', '_'));
    const suffix = codes.length > 0 ? ` Codes: ${codes.join(', ')}.` : '';
    return {
        description: `${description}${suffix}`,
        content: { [PROBLEM_CONTENT_TYPE]: { schema: ProblemSchema } },
    };
}
/**
 * The codes a problem response's description names — `problemResponse` read back, so a reader of the
 * generated document (the error reference's list of endpoints per code, `apps/errors`) needs no second
 * copy of the format. A description that names none gives an empty list.
 */
export function problemResponseCodes(description) {
    const named = / Codes: ([a-z][a-z0-9]*(?:_[a-z0-9]+)*(?:, [a-z][a-z0-9]*(?:_[a-z0-9]+)*)*)\.$/.exec(description);
    return named?.[1]?.split(', ') ?? [];
}
/** The failures every endpoint can return, whatever else it declares. */
export const commonProblemResponses = {
    400: problemResponse('The request could not be understood.', 'validation-failed'),
    401: problemResponse('Not signed in.', 'unauthenticated'),
    403: problemResponse('Not allowed.', 'forbidden', 'second-factor-required'),
    429: problemResponse('Too many requests.', 'rate-limited'),
    500: problemResponse('Something went wrong.', 'internal-error'),
    503: problemResponse('Busy; try again after `Retry-After`.', 'service-unavailable'),
};
/** Every status the catalogue can produce, so a generated client can switch on all of them. */
export const CATALOGUE_STATUSES = [
    ...new Set(Object.values(ERROR_CATALOGUE).map((definition) => definition.status)),
].sort((a, b) => a - b);
//# sourceMappingURL=responses.js.map